import React from 'react';

import AddRecipientsForm from 'src/presentation/components/pages/proactiveCommunications/components/shared/AddRecipientsForm';

const AddEmailRecipientsForm = ({ campaign, item, root, 'data-aid': dataAid }) => {
  const startDateTimeDescription = (
    <>
      Set the date and time when Gladly starts sending emails to your recipients. Emails will only be sent during the
      set Campaign
      <br /> schedule hours.
    </>
  );

  return (
    <AddRecipientsForm
      campaign={campaign}
      data-aid={dataAid}
      item={item}
      root={root}
      startDateTimeDescription={startDateTimeDescription}
    />
  );
};

export default AddEmailRecipientsForm;
